import { getClientPromptSessionId } from './clientMobileAppPrompt';

// Reads the unverified JWT payload. The result is a UI hint only; the API
// enforces every permission itself.
function readClaims(accessToken?: string | null): Record<string, unknown> | null {
   if (!accessToken) return null;
   try {
      const parts = accessToken.split('.');
      if (parts.length !== 3) return null;
      const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
      const claims: unknown = JSON.parse(
         atob(payload.padEnd(Math.ceil(payload.length / 4) * 4, '=')),
      );
      return claims && typeof claims === 'object' ? claims as Record<string, unknown> : null;
   } catch {
      return null;
   }
}

export function isImpersonatingClientToken(accessToken?: string | null) {
   return readClaims(accessToken)?.is_impersonating === true;
}

// Separates an admin impersonating a client from that client's own session so
// state cached for one is never shown to the other.
export function clientAccountKey(accessToken?: string | null): string | null {
   const account = getClientPromptSessionId(accessToken);
   if (!account) return null;
   return isImpersonatingClientToken(accessToken) ? `${account}:impersonated` : account;
}
